"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactDom = require("react-dom");

var _bodyScrollLock = require("body-scroll-lock");

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _mobileContainer = _interopRequireDefault(require("./mobileContainer"));

var _mobileContent = _interopRequireDefault(require("./mobileContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react-hooks/exhaustive-deps */
var useStyles = (0, _makeStyles.default)(function () {
  return {
    root: {
      inset: 0,
      overflow: "auto",
      position: "fixed",
      width: "100%",
      zIndex: 1000
    }
  };
});

var Mobile = function Mobile(_ref) {
  var backLabel = _ref.backLabel,
      close = _ref.close,
      iconBottom = _ref.iconBottom,
      iconClose = _ref.iconClose,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      mainmenu = _ref.mainmenu,
      metamenu = _ref.metamenu;
  var css = useStyles();
  (0, _react.useEffect)(function () {
    document.body.appendChild(el.current);
    (0, _bodyScrollLock.disableBodyScroll)(el.current);
    return function () {
      if (el.current.parentElement) {
        el.current.parentElement.removeChild(el.current);
        (0, _bodyScrollLock.clearAllBodyScrollLocks)();
      }
    };
  }, []);
  var el = (0, _react.useRef)(document.createElement("div"));
  el.current.className = (0, _clsx.default)("menu-01-mobile", css.root);
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(_mobileContainer.default, {
    close: close,
    iconClose: iconClose
  }, /*#__PURE__*/_react.default.createElement(_mobileContent.default, {
    backLabel: backLabel,
    mainmenu: mainmenu,
    metamenu: metamenu,
    iconBottom: iconBottom,
    iconLeft: iconLeft,
    iconRight: iconRight
  })), el.current);
};

Mobile.propTypes = {
  backLabel: _propTypes.default.string,
  close: _propTypes.default.func.isRequired,
  iconBottom: _propTypes.default.string,
  iconClose: _propTypes.default.string.isRequired,
  iconLeft: _propTypes.default.string,
  iconRight: _propTypes.default.string,
  mainmenu: _propTypes.default.object.isRequired,
  metamenu: _propTypes.default.object
};
var _default = Mobile;
exports.default = _default;